'use client'
import React, { useContext, useEffect, useState } from 'react'
import Modules from './Modules/Modules'
import { HomeParametersObject, IPatient } from '@umahealth/entities'
import { IClientState } from '@/config/clients'
import { chatAttContext } from '@/OldRouter/Providers/ProviderChatAtt'
import CountryModal from '../Modals/components/CountryModal'
import NotificationCard from './Components/NotificationCard'
import { usePostHog } from 'posthog-js/react'
import { usePosthogIdentifyClient } from '@/hooks/usePosthogIdentifyClient'
import { saveUtmParams } from '@/context/saveUtmParams'
import { SurveysFlags } from './Utils/surveysFlags'
import PosthogSurveys, { PosthogSurveysType } from '../GeneralComponents/PosthogSurveys/PosthogSurveys'
import Cookies from 'js-cookie'
import PromotionalBanner from '../Subscriptions/components/PromotionalBanner/PromotionalBanner'
import { useRouter } from 'next/navigation'
import { ISubscriptionWithId } from '@umahealth/fe-firebase/src/Firestore-Query/Subscription/useSuscription'

interface IHomepage {
	homeParameters: HomeParametersObject
	client: IClientState
	country: 'AR' | 'MX' | undefined,
	surveysFlags?: SurveysFlags,
	patient: IPatient
	searchParams: {
		utm_source?: string,
		utm_medium?: string,
		utm_campaign?: string,
	}
	activeSubscription: ISubscriptionWithId | undefined
}

function Homepage({
	client,
	homeParameters,
	country,
	surveysFlags,
	patient,
	searchParams,
	activeSubscription
}: IHomepage) {
	const chatAtt = useContext(chatAttContext)
	const [countrySelected, setCountrySelected] = useState<string | null>(null)
	const [showPromoBanner, setShowPromoBanner] = useState(false)
	const dbCountryCoincidence = patient?.country !== process.env.NEXT_PUBLIC_COUNTRY
	const posthog = usePostHog()
	const [activeSurveys, setActiveSurveys] = useState<PosthogSurveysType>({
		nps: null,
		physicalCert: null,
	})
	const router = useRouter()
	const new_users_add = Cookies.get('new_users_add')

	usePosthogIdentifyClient(patient)

	useEffect(() => {
		setCountrySelected(window.localStorage.getItem('selectedCountry'))
		saveUtmParams({ objSearchParams: searchParams })

		const hasNewUserCookie = Cookies.get('new_users_add')
		if (hasNewUserCookie) {
			setShowPromoBanner(true)
		}
	}, [])

	useEffect(() => {
		if (patient && posthog && surveysFlags) {
			posthog?.getSurveys((surveys) => {
				const surveysNames = Object.keys(surveysFlags) as Array<keyof SurveysFlags>
				for(const surveyName of surveysNames) {
					if (surveys.length && surveysFlags[surveyName].active) {
						const targetingSurvey = surveys.find((survey) => survey.targeting_flag_key === surveysFlags[surveyName].key)
						if (targetingSurvey) {
							setActiveSurveys((prevState) => ({
								...prevState,
								[surveyName]: targetingSurvey,
							}))
						}
					}
				}
			}, true)
		}
	}, [patient, posthog, surveysFlags])

	if (
		dbCountryCoincidence &&
		countrySelected != process.env.NEXT_PUBLIC_COUNTRY &&
		country === undefined
	) {
		return (
			<CountryModal
				patientCountry={patient?.country}
				serverCountry={process.env.NEXT_PUBLIC_COUNTRY}
			/>
		)
	}

	return (
		<>
			<Modules
				chatAtt={chatAtt}
				client={client}
				user={patient || null}
				homeParameters={homeParameters}
			/>
			<NotificationCard />
			<PosthogSurveys posthogSurveys={activeSurveys} />

			{showPromoBanner && !activeSubscription && (
				<div 
					onTouchStart={()=> {
						router.push(`/checkout/${new_users_add}`)
					}} 
					className="fixed flex flex-col justify-center p-6 inset-0 bg-black bg-opacity-70 z-50 flex items-center"
				>
					<PromotionalBanner path={`/checkout/${new_users_add}`} />
					<div className="absolute bottom-16 flex flex-col items-center justify-center w-full max-w-md">

						<p className="mt-6 text-white text-center text-md font-bold">
							Toca para acceder a tu beneficio
						</p>
					</div>
				</div>
			)}
		</>
	)
}

export default Homepage
